import { inject, Injectable } from '@angular/core'
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker'
import { filter, map } from 'rxjs/operators'
import { ToastController } from '@ionic/angular'
import packagejson from '../../../../package.json'

@Injectable({
  providedIn: 'root',
})
export class PwaAppUpdateService {
  private swUpdate = inject(SwUpdate)
  private toaster = inject(ToastController)

  public packageVersion: string = packagejson.version

  async init() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(
          filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
          map((evt) => ({
            type: 'UPDATE_AVAILABLE',
            current: evt.currentVersion,
            available: evt.latestVersion,
          })),
        )
        .subscribe((evtRes) => {
          console.log('New version ready', evtRes)
          console.log('Current version from package.json', this.packageVersion)
          const version = (evtRes.available.appData as { version: string }).version
          console.log('New version from appData', version)
          if (version === this.packageVersion) {
            this.showAlreadyUpdatedToast(version)
          } else {
            this.showNewVersionToast(version)
          }
        })
    }

    await this.initVersionCheck()
  }

  private async initVersionCheck(frequencySeconds = 60) {
    await this.swUpdate.checkForUpdate()
    setInterval(async () => {
      await this.swUpdate.checkForUpdate()
    }, frequencySeconds * 1000)
  }

  private async showAlreadyUpdatedToast(version: string) {
    const toast = await this.toaster.create({
      header: `Aspik byl aktualizován na verzi (${version}).`,
      position: 'top',
      buttons: [
        {
          text: '',
          icon: 'close',
          role: 'cancel',
          handler: () => {},
        },
      ],
    })
    await toast.present()
  }

  private async showNewVersionToast(version: string) {
    const toast = await this.toaster.create({
      header: `Nová verze Aspiku (${version}) je k dispozici!`,
      position: 'top',
      buttons: [
        {
          side: 'end',
          icon: 'reload-outline',
          text: 'Aktualizovat',
          handler: () => {
            location.reload()
          },
        },
        {
          text: '',
          icon: 'close',
          role: 'cancel',
          handler: () => {},
        },
      ],
    })
    await toast.present()
  }
}
